import { useEffect, useState, type ReactNode } from 'react';
import { localSiteConfig, watchSiteConfig } from '../lib/siteConfig';
import { FullPageLoader } from './guards';
import { SiteModeContext, type SiteModeState } from './siteModeContext';

function initialState(): SiteModeState | null {
  const local = localSiteConfig();
  return local ? { config: local } : null;
}

/** Holds the app behind a loader until the site mode is known, so nothing flashes before the gate. */
export function SiteModeProvider({ children }: { children: ReactNode }) {
  const [state, setState] = useState<SiteModeState | null>(initialState);
  const [needsRemote] = useState(() => localSiteConfig() === null);

  useEffect(() => {
    if (!needsRemote) return;
    return watchSiteConfig((config) => setState({ config }));
  }, [needsRemote]);

  if (!state) return <FullPageLoader />;
  return <SiteModeContext.Provider value={state}>{children}</SiteModeContext.Provider>;
}
